<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green my-row">
          <div class="card-icon">
            <md-icon>sports_esports</md-icon>
          </div>
          <h4 class="title">{{ sn }}</h4>
        </md-card-header>
        <h5 class="my-center-row">{{ address }}</h5>
        <div class="my-row">
          <md-button class="my-md-button md-success" @click.native="load()">
            <span class="material-icons">refresh</span>
            Обновить
          </md-button>
        </div>
        <div class="my-row">
          <md-button
            class="my-md-button md-success"
            @click.native="backToApvs()"
          >
            к аппаратам
          </md-button>
        </div>
        <div class="my-center-row my-bold">
          <div
            class="current-command"
            v-if="
              apvProfile && apvProfile.cmdProfile && apvProfile.cmdProfile.cmd
            "
          >
            Текущая команда: <br />
            {{ commands[apvProfile.cmdProfile.cmd] }}
          </div>

          <div class="current-command" v-else>Нет команды в очереди</div>
        </div>

        <div class="my-row">
          <md-button
            class="my-md-button md-warning"
            @click.native="resetCommand()"
          >
            Сбросить команду
          </md-button>
        </div>
        <div class="my-row">
          <md-button
            class="my-md-button md-success"
            @click.native="backToMessages()"
          >
            к сообщениям
          </md-button>
        </div>
        <md-card-content>
          <div v-for="row in commandsLocation" :key="row.cmd">
            <md-button
              class="md-info my-md-button"
              @click="row.showDialog = true"
            >
              {{ commands[row.cmd] }}
              <md-dialog-confirm
                :md-active.sync="row.showDialog"
                md-title="Подтвердите операцию"
                :md-content="confirmText(commands[row.cmd])"
                md-confirm-text="Подтверждаю"
                md-cancel-text="Отмена"
                @md-cancel="row.showConfirmDialog = false"
                @md-confirm="action(row)"
              />
            </md-button>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {},
  data() {
    return {
      commands: {
        "app:on": "Включить аппарат",
        "app:off": "Выключить аппарат",
        "app:reset": "Перегрузить аппарат",
        "tara:off": "Выключить бесплатный налив",
        "tara:on": "Включить бесплатнгый налив",
        "tara:pop": "Пополнить тару",
        "temp:off": "Выключить обогреватель",
        "temp:on": "Включить обогреватель",
        "kup:off": "Выключить купюроприёмникник",
        "kup:on": "Включить купюроприёмник",
        "mon:off": "Выключить монетоприёмник",
        "mon:on": "Включить монетоприёмник",
        "rd:off": "Выключить модуль б/н оплаты",
        "rd:on": "Включить модуль б/н оплаты",
        "alarm:off": "Выключить сигнализацию",
        "san:on": "Вкл. Санитарную обработку",
        "san:off": "Выкл. Санитарную обработку",
        info: "Запросить состояние",
        inkas1: "Cлот #1",
        inkas2: "Слот #2",
        inkas3: "Слот #3",
        inkas4: "Слот #4",
        inkas5: "Слот #5",
        inkas6: "Слот #6",
        inkas7: "Слот #7",
      },
      commandsLocation: [
        { cmd: "app:on", showDialog: false },
        { cmd: "app:off", showDialog: false },
        { cmd: "app:reset", showDialog: false },
        { cmd: "tara:off", showDialog: false },
        { cmd: "tara:on", showDialog: false },
        { cmd: "tara:pop", showDialog: false },
        { cmd: "temp:off", showDialog: false },
        { cmd: "temp:on", showDialog: false },
        { cmd: "kup:off", showDialog: false },
        { cmd: "kup:on", showDialog: false },
        { cmd: "mon:off", showDialog: false },
        { cmd: "mon:on", showDialog: false },
        { cmd: "rd:off", showDialog: false },
        { cmd: "rd:on", showDialog: false },
        { cmd: "san:on", showDialog: false },
        { cmd: "san:off", showDialog: false },
        { cmd: "alarm:off", showDialog: false },
        { cmd: "info", showDialog: false },
      ],
      sn: "",
      apvProfile: {},
      model: [],
      showDialog: false,
      address: "",
    };
  },
  methods: {
    backToMessages() {
      this.$router.push({ path: "/EngMessages", query: this.$route.query });
    },
    backToApvs() {
      this.$router.push({ path: "/EngApvsIndex", query: this.$route.query });
    },
    confirmText(cmdTitle) {
      return `Подтверждаете операцию "${cmdTitle}" ?`;
    },
    showErrorNotify(r) {
      this.$notify({
        message: `<h3>${r.errorCode}</h3>` + `<p>${r.errorMessage}</p>`,
        icon: "add_alert",
        horizontalAlign: "center",
        verticalAlign: "top",
        type: "warning",
      });
    },
    showSuccessNotify(r) {
      this.$notify({
        message: `<h3>${r.title}</h3>` + `<p>${r.message}</p>`,
        icon: "add_alert",
        horizontalAlign: "center",
        verticalAlign: "top",
        type: "success",
      });
    },
    action(cmd) {
      this.showDialog = false;

      this.ajax.setCmdByEng(
        this,
        {
          sn: this.sn,
          cmd: cmd.cmd,
        },
        (r) => {
          if (r.status == "ok") {
            this.showSuccessNotify({
              title: "OK",
              message: "Команда принята на обработку",
            });
            this.load();
          } else {
            this.showErrorNotify(r);
          }
        },
        (err) => {
          //console.log(err);
        }
      );
    },
    resetCommand() {
      this.ajax.dropCmdByEng(
        this,
        { sn: this.sn },
        (r) => {
          if (r.status == "ok") {
            this.load();
          } else {
            this.showErrorNotify(r);
          }
        },
        (err) => {
          // console.log(err);
        }
      );
    },
    load() {
      const sn = this.$route.query.sn;
      this.address = this.$route.query.item.address;
      this.sn = sn;
      this.ajax.getApvBySN(
        this,
        { sn },
        (r) => {
          if (r.status == "ok") {
            this.apvProfile = r.data[0];
          } else {
            this.showErrorNotify(r);
          }
        },
        (err) => {
          // console.log(err);
        }
      );
    },
  },
  mounted() {
    this.load();
  },
  watch: {},
};
</script>

<style lang="css" scoped>
.md-tabs {
  margin-bottom: 24px;
}

.material-icons {
  margin-right: 15px;
}

.my-md-button {
  width: 100%;
  height: 41px;
  margin-top: 5px;
  margin-bottom: 0px;
  margin-right: 20px;
}

.my-center-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.my-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-left: 20px;
}

.my-bold {
  font-weight: bold;
}

.current-command {
  height: 60px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
